import { Component, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { Guid } from '../../guid';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'ef-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {
    @Input() processing: boolean;
    @Input() processingText: string;

    private _loading: boolean = false;
    private _showDelayedLoading: boolean = false;
    private _loadingTimer: any;
    private readonly LOADING_DELAY_MS = 2000;

    @Input()
    public set loading(value: boolean) {
        this._loading = value;
        this.handleLoadingChange(value);
    }

    public get loading(): boolean {
        return this._loading;
    }

    public get showDelayedLoading(): boolean {
        return this._showDelayedLoading;
    }

    private _loadingTextSubject = new ReplaySubject<string>(1);
    private _loadingtext: string;
    @Input() public set loadingText(value: string) {
        this._loadingtext = value;
        this._loadingTextSubject.next(value);
    }
    get loadingText(): string {
        return this._loadingtext;
    }

    id: string = Guid.newGuid();

    private handleLoadingChange(isLoading: boolean): void {
        if (isLoading) {
            this._loadingTimer = setTimeout(() => {
                if (this._loading) {
                    this._showDelayedLoading = true;
                }
            }, this.LOADING_DELAY_MS);
        } else {
            if (this._loadingTimer) {
                clearTimeout(this._loadingTimer);
                this._loadingTimer = null;
            }
            this._showDelayedLoading = false;
        }
    }

    public get shouldShow() {
        const overlays = Array.from(
            document.getElementsByClassName('page-overlay')
        );
        const overlayCount = overlays.length;
        const firstOverlayId = (overlays[0] && overlays[0].id) || null;
        return (
            (overlays.length > 1 && firstOverlayId === this.id) ||
            overlays.length === 0
        );
    }

    public get logoPath(): string {
        return 'images/eflogotransparent-avalon-dark.png'; //'images/eflogotransparent-avalon.png';
    }

    constructor(private element: ElementRef) {}

    ngOnInit() {
        if (this.loadingText == null) {
            this.loadingText = 'Loading...';
        }
    }

    ngOnDestroy() {
        if (this._loadingTimer) {
            clearTimeout(this._loadingTimer);
        }
    }
}
